import React, { PureComponent } from 'react';

import {
  CheckBox as CheckBoxIcon,
  Done as CheckIcon,
  Block as NoneIcon,
} from '@mui/icons-material';

import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  FormControlLabel,
  Switch,
} from '@mui/material';

import Tile from '../../../common/components/Tile/Tile';

import PermissionsCheck from '../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../common/constants/PermissionsEnum';

class PermissionsRole extends PureComponent {
  render() {
    return (
      <Tile
        title="Permissions"
        TitleIcon={CheckBoxIcon}
        helpTag="permissions"
        data-qa="qa-permissions-table"
      >
        <Table style={{ width: '60%' }}>
          <TableHead displaySelectAll={false}>
            <TableRow>
              <TableCell style={{ width: '25%' }}>Permission \ Profile </TableCell>
              {this.props.rols.map((el, index) => (
                <TableCell style={{ textAlign: 'center' }} key={el.RoleEntityId}>
                  {el.Name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.permissions.map((perm, index) => (
              <TableRow key={perm.Value}>
                <TableCell style={{ width: '25%' }}>{perm.Name}</TableCell>
                {this.props.rols.map((role, index) => (
                  <TableCell style={{ textAlign: 'center' }} key={role.RoleEntityId}>
                    <PermissionsCheck permission={PermissionsEnum.EDIT_PERMISSIONS}>
                      <FormControlLabel
                        control={
                          <Switch
                            data-qa="qa-nameofpermission-userrole"
                            disabled={perm.IsUserPermission}
                            checked={
                              this.props.rolePermissions[role.RoleEntityId][perm.Value]
                                ? true
                                : false
                            }
                            onChange={() => {
                              this.props.onChange(role, perm);
                            }}
                          />
                        }
                      />
                    </PermissionsCheck>
                    <PermissionsCheck
                      permission={PermissionsEnum.EDIT_PERMISSIONS}
                      hasPermission={false}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            disabled={true}
                            data-qa="qa-nameofpermission-userrole"
                            checked={
                              this.props.rolePermissions[role.RoleEntityId][perm.Value]
                                ? true
                                : false
                            }
                            onChange={() => {
                              this.props.onChange(role, perm);
                            }}
                          />
                        }
                      />
                    </PermissionsCheck>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Tile>
    );
  }
}

export default PermissionsRole;
